import { createContext, useContext, useState } from "react";

const DEMO_USERS = [
  {
    identifier: "admin@aligned.com",
    label: "Procurement Admin",
    role: "procurement",
    description: "Full access — all vendors, all data",
    color: "#C9972B",
    badge: "INTERNAL",
  },
  {
    identifier: "jared.w@aligned.com",
    label: "Project Management",
    role: "project_mgmt",
    description: "Schedule + financials access",
    color: "#a78bfa",
    badge: "INTERNAL",
  },
  {
    identifier: "cxa@aligned.com",
    label: "CxA (Commissioning)",
    role: "cxa",
    description: "Commissioning status + contacts",
    color: "#38bdf8",
    badge: "INTERNAL",
  },
  {
    identifier: "se-pm@solaredge.com",
    label: "SolarEdge (Vendor)",
    role: "vendor",
    description: "Inverter items only — vendor scoped",
    color: "#34d399",
    badge: "VENDOR",
  },
  {
    identifier: "ops@blattner.com",
    label: "Blattner (Integrator)",
    role: "integrator",
    description: "Storage locations + delivery status",
    color: "#34d399",
    badge: "EXTERNAL",
  },
];

const ProcurementUserContext = createContext(null);

export function ProcurementUserProvider({ children }) {
  const [activeUser, setActiveUser] = useState(DEMO_USERS[0]);

  return (
    <ProcurementUserContext.Provider
      value={{ activeUser, setActiveUser, DEMO_USERS }}
    >
      {children}
    </ProcurementUserContext.Provider>
  );
}

export function useProcurementUser() {
  const ctx = useContext(ProcurementUserContext);
  if (!ctx) throw new Error(
    "useProcurementUser must be used within ProcurementUserProvider"
  );
  return ctx;
}

export { DEMO_USERS };
